/*
 * DO NOT EDIT
 * ===========
 * This file was auto-generated.
 * To update run the TypeScript Code Generator in the API.
 */

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { REGISTER_PLACEHOLDER } from '@assetaccountant/core/http-token.interceptor';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { CreateAssetGroupCommand } from '../models/asset-groups/create-asset-group.command';
import { CreateAssetGroupResponse } from '../models/asset-groups/create-asset-group.response';
import { ListAssetGroupsQuery } from '../models/asset-groups/list-asset-groups.query';
import { ListAssetGroupsResponse } from '../models/asset-groups/list-asset-groups.response';
import { SearchAssetsQuery } from '../models/assets/search-assets.query';
import { SearchAssetsResponse } from '../models/assets/search-assets.response';
import { IgnoreDraftAssetsCommand } from '../models/draft-assets/ignore-draft-assets.command';
import { RestoreDraftAssetsCommand } from '../models/draft-assets/restore-draft-assets.command';
import { CreateFieldCommand } from '../models/fields/create-field.command';
import { CreateFieldResponse } from '../models/fields/create-field.response';
import { DeleteFieldCommand } from '../models/fields/delete-field.command';
import { GetFieldQuery } from '../models/fields/get-field.query';
import { GetFieldResponse } from '../models/fields/get-field.response';
import { ListFieldsResponse } from '../models/fields/list-fields.response';
import { SaveFieldCommand } from '../models/fields/save-field.command';
import { SaveFieldResponse } from '../models/fields/save-field.response';
import { UpdateFieldCommand } from '../models/fields/update-field.command';
import { UpdateFieldResponse } from '../models/fields/update-field.response';
import { PoolDto } from '../models/pool.dto';
import { RegimeDto } from '../models/regime.dto';
import { InviteOrUpdateRegisterUserCommand } from '../models/register-invitation/invite-or-update-register-user.command';
import { InviteOrUpdateRegisterUsersCommand } from '../models/register-invitation/invite-or-update-register-users.command';
import { ListAvailableRegisterIntegrationsQuery } from '../models/registers/list-available-register-integrations.query';
import { ListAvailableRegisterIntegrationsResponse } from '../models/registers/list-available-register-integrations.response';
import { ListRegisterIntegrationsResponse } from '../models/registers/list-register-integrations.response';
import { ListRegisterPermissionsResponse } from '../models/registers/list-register-permissions.response';
import { ListRegisterRolesQuery } from '../models/registers/list-register-roles.query';
import { ListRegisterRolesResponse } from '../models/registers/list-register-roles.response';
import { ListRegisterUsersQuery } from '../models/registers/list-register-users.query';
import { ListRegisterUsersResponse } from '../models/registers/list-register-users.response';
import { ListRegistersResponse } from '../models/registers/list-registers.response';
import { RemoveRegisterUserCommand } from '../models/registers/remove-register-user.command';
import { UpdateRegisterCommand } from '../models/registers/update-register.command';
import { UpdateRegisterResponse } from '../models/registers/update-register.response';
import { ListTagsResponse } from '../models/tags/list-tags.response';
import { SaveRegisterTagsCommand } from '../models/tags/save-register-tags.command';

@Injectable({
  providedIn: 'root',
})
export class RegisterV2Api {
  constructor(private http: HttpClient) {}

  createAssetGroup(command: CreateAssetGroupCommand): Observable<CreateAssetGroupResponse> {
    return this.http.post<CreateAssetGroupResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/assetGroups`,
      command,
    );
  }

  createField(command: CreateFieldCommand): Observable<CreateFieldResponse> {
    return this.http.post<CreateFieldResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/fields`,
      command,
    );
  }

  deleteField(command: DeleteFieldCommand): Observable<void> {
    return this.http.delete<void>(
      `${environment.servicesApiUrl}/api/v2/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/classifications/${command.fieldId}`,
    );
  }

  getField(query: GetFieldQuery): Observable<GetFieldResponse> {
    return this.http.get<GetFieldResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${query.registerId ?? REGISTER_PLACEHOLDER}/fields/${query.fieldId}`,
    );
  }

  getRegisterPools(options: { registerId?: number } = {}): Observable<PoolDto[]> {
    return this.http.get<PoolDto[]>(
      `${environment.servicesApiUrl}/api/v2/registers/${options.registerId ?? REGISTER_PLACEHOLDER}/pools`,
    );
  }

  getRegisterRegimes(options: { registerId?: number } = {}): Observable<RegimeDto[]> {
    return this.http.get<RegimeDto[]>(
      `${environment.servicesApiUrl}/api/v2/registers/${options.registerId ?? REGISTER_PLACEHOLDER}/regimes`,
    );
  }

  ignoreDraftAssets(command: IgnoreDraftAssetsCommand): Observable<void> {
    return this.http.delete<void>(
      `${environment.servicesApiUrl}/api/v2/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/draftAssets`,
      {
        body: command,
        params: {
          ...(command.integrationType ? { integrationType: command.integrationType } : {}),
        },
      },
    );
  }

  inviteOrUpdateRegisterUser(command: InviteOrUpdateRegisterUserCommand): Observable<void> {
    return this.http.post<void>(
      `${environment.servicesApiUrl}/api/v2/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/user`,
      command,
    );
  }

  inviteUser(command: InviteOrUpdateRegisterUsersCommand): Observable<void> {
    return this.http.post<void>(
      `${environment.servicesApiUrl}/api/v2/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/users`,
      command,
    );
  }

  listAssetGroups(query: ListAssetGroupsQuery = {}): Observable<ListAssetGroupsResponse> {
    return this.http.get<ListAssetGroupsResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${query.registerId ?? REGISTER_PLACEHOLDER}/assetGroups`,
      { params: { ...(query.includeInactive ? { includeInactive: query.includeInactive } : {}) } },
    );
  }

  listAvailableIntegrations(
    query: ListAvailableRegisterIntegrationsQuery = {},
  ): Observable<ListAvailableRegisterIntegrationsResponse> {
    return this.http.get<ListAvailableRegisterIntegrationsResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${query.registerId ?? REGISTER_PLACEHOLDER}/available-integrations`,
      { params: { ...(query.forDraftAssets ? { forDraftAssets: query.forDraftAssets } : {}) } },
    );
  }

  listFields(registerId?: number | null): Observable<ListFieldsResponse> {
    return this.http.get<ListFieldsResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${registerId ?? REGISTER_PLACEHOLDER}/fields`,
    );
  }

  listIntegrations(registerId?: number | null): Observable<ListRegisterIntegrationsResponse> {
    return this.http.get<ListRegisterIntegrationsResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${registerId ?? REGISTER_PLACEHOLDER}/integrations`,
    );
  }

  listPermissions(registerId?: number | null): Observable<ListRegisterPermissionsResponse> {
    return this.http.get<ListRegisterPermissionsResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${registerId ?? REGISTER_PLACEHOLDER}/permissions`,
    );
  }

  listRegisters(): Observable<ListRegistersResponse> {
    return this.http.get<ListRegistersResponse>(`${environment.servicesApiUrl}/api/v2/registers`);
  }

  listRoles(query: ListRegisterRolesQuery = {}): Observable<ListRegisterRolesResponse> {
    return this.http.get<ListRegisterRolesResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${query.registerId ?? REGISTER_PLACEHOLDER}/roles`,
      { params: { ...(query.organisationId ? { organisationId: query.organisationId } : {}) } },
    );
  }

  listTags(registerId?: number | null): Observable<ListTagsResponse> {
    return this.http.get<ListTagsResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${registerId ?? REGISTER_PLACEHOLDER}/tags`,
    );
  }

  listUsers(query: ListRegisterUsersQuery = {}): Observable<ListRegisterUsersResponse> {
    return this.http.get<ListRegisterUsersResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${query.registerId ?? REGISTER_PLACEHOLDER}/users`,
      { params: { ...(query.includeInvited ? { includeInvited: query.includeInvited } : {}) } },
    );
  }

  removeUser(command: RemoveRegisterUserCommand): Observable<void> {
    return this.http.delete<void>(
      `${environment.servicesApiUrl}/api/v2/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/users/${command.userIdToRemove}`,
    );
  }

  restoreDraftAssets(command: RestoreDraftAssetsCommand): Observable<void> {
    return this.http.put<void>(
      `${environment.servicesApiUrl}/api/v2/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/draftAssets`,
      command,
      {
        params: {
          ...(command.integrationType ? { integrationType: command.integrationType } : {}),
        },
      },
    );
  }

  saveClassification(command: SaveFieldCommand): Observable<SaveFieldResponse> {
    return this.http.post<SaveFieldResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/classifications`,
      command,
    );
  }

  search(query: SearchAssetsQuery = {}): Observable<SearchAssetsResponse> {
    return this.http.get<SearchAssetsResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${query.registerId ?? REGISTER_PLACEHOLDER}/assets/search`,
      {
        params: {
          ...(query.searchCriteria ? { searchCriteria: query.searchCriteria } : {}),
          ...(query.numberOfResults ? { numberOfResults: query.numberOfResults } : {}),
        },
      },
    );
  }

  setTags(command: SaveRegisterTagsCommand): Observable<void> {
    return this.http.put<void>(
      `${environment.servicesApiUrl}/api/v2/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/tags`,
      command,
    );
  }

  updateField(command: UpdateFieldCommand): Observable<UpdateFieldResponse> {
    return this.http.put<UpdateFieldResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${command.registerId ?? REGISTER_PLACEHOLDER}/fields/${command.fieldId}`,
      command,
    );
  }

  updateLastAccessed(registerId?: number | null): Observable<void> {
    return this.http.get<void>(
      `${environment.servicesApiUrl}/api/v2/registers/${registerId ?? REGISTER_PLACEHOLDER}/access`,
    );
  }

  updateRegister(command: UpdateRegisterCommand): Observable<UpdateRegisterResponse> {
    return this.http.put<UpdateRegisterResponse>(
      `${environment.servicesApiUrl}/api/v2/registers/${command.registerId ?? REGISTER_PLACEHOLDER}`,
      command,
    );
  }
}
